import { useEffect } from "react";

import { useNotificationsContext } from "@/contexts/Notification";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { USER_NOTIFICATION_FIELDS } from "@/graphql/notifications/types";
import { gql, useQuery } from "@apollo/client";

import LinkYourBankAccount from "../ui/LinkYourBankAccount";
import NotificationModal from "../ui/NotificationModal";
import PlannedSystemMaintenance from "../ui/PlannedSystemMaintenance";

const ON_CMP_LOGIN_QUERY = gql`
  query OnCmpLoginQuery($organisation: ID!) {
    onCmpLogin(organisation: $organisation) {
      ...UserNotificationFields
    }
  }
  ${USER_NOTIFICATION_FIELDS}
`;

export default function OnCmpLogin() {
  /**
   * Event: when the partner logs in to the cmp for the first time, or the app loads with the user
   * logged in already for the first time
   */

  const api = useNotificationsContext();
  const { organisation } = useOrganisationContext();

  const { data } = useQuery(ON_CMP_LOGIN_QUERY, {
    variables: { organisation: organisation?.id },
    skip: !organisation?.id
  });

  useEffect(() => {
    if (data) {
      api.addNotifications(data.onCmpLogin);
    }
  }, [api, data]);

  const userNotification = api.nextNotification(un => {
    if (
      ["cmp.UserMissingLinkedBankAccount", "accounts.PlannedSystemMaintenance"].includes(
        un.notification.type
      )
    ) {
      return true;
    }
    return false;
  });

  return userNotification ? (
    <NotificationModal onClose={() => api.acknowledgeNotification(userNotification.id)}>
      {userNotification.notification.type === "cmp.UserMissingLinkedBankAccount" && (
        <LinkYourBankAccount />
      )}
      {userNotification.notification.type === "accounts.PlannedSystemMaintenance" && (
        <PlannedSystemMaintenance
          from={userNotification.notification.validFrom}
          to={userNotification.notification.validTo}
        />
      )}
    </NotificationModal>
  ) : null;
}
